import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserBenefits = ({ userId, groupId }) =>
  call(websocketFetch, 'get_user_benefits', {
    user_id: userId,
    group_id: groupId,
    options: ['include_grace_period'],
  });
